import { render, staticRenderFns } from "./carCreateFeeAdd.vue?vue&type=template&id=b78845dc&scoped=true"
import script from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeAdd.vue?vue&type=style&index=0&id=b78845dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78845dc",
  null
  
)

export default component.exports